  import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../../../context/ProductBuilder/machine';
// import { getPatternImages } from '../../../../../helpers/getPatternImages';
import { CurtainCeilingDoublePleatCentreOpening } from './CurtainCeilingDoublePleatCentreOpening';
import { CurtainCeilingMountWaveFoldCentreOpening } from './CurtainCeilingMountWaveFoldCentreOpening';
import { CurtainFaceMountDoublePleatCentreOpening } from './CurtainFaceMountDoublePleatCentreOpening';
import { CurtainFaceMountDoublePleatLeftStack } from './CurtainFaceMountDoublePleatLeftStack';
import { CurtainFaceMountDoublePleatRightStack } from './CurtainFaceMountDoublePleatRightStack';
import { CurtainFaceMountSinglePleatCentreOpening } from './CurtainFaceMountSinglePleatCentreOpening';
import { CurtainFaceMountSinglePleatLeftStack } from './CurtainFaceMountSinglePleatLeftStack';
import { CurtainFaceMountSinglePleatRightStack } from './CurtainFaceMountSinglePleatRightStack';
import { CurtainFaceMountWaveFoldLeftStack } from './CurtainFaceMountWaveFoldLeftStack';
import { CurtainFaceMountWaveFoldRightStack } from './CurtainFaceMountWaveFoldRightStack';
import { CurtainWaveFoldFaceMount } from './CurtainWaveFoldFaceMount';

// export const BuilderWindow = React.forwardRef(
//   (props: React.SVGProps<SVGSVGElement>, setRef: React.Ref<SVGSVGElement>) => {
export const Curtains = React.forwardRef(
  (
    props: React.SVGProps<SVGSVGElement>,
    setProductImageRef: React.Ref<SVGSVGElement>,
  ) => {
    const [state] = useService(productBuilderMachine);
    console.log(state,"statestatestate")

    const fitting =
      state.context.custom.fitting === 'Ceiling Mount'
        ? 'Ceiling Mount'
        : 'Wall Mount';

    const configuration = state.context.custom.configuration
      ? state.context.custom.configuration
      : 'Centre Opening (2 Curtains)';
    const pleatType = state.context.custom.pleatType
      ? state.context.custom.pleatType
      : 'Wave Pleat';
    if (
      fitting !== 'Ceiling Mount' &&
      pleatType === 'Wave Pleat' &&
      configuration === 'Centre Opening (2 Curtains)'
    ) {
      console.log('1',"======>kartik");
      return <CurtainWaveFoldFaceMount {...props} ref={setProductImageRef} />;
    } else if (
      pleatType === 'Double Pleat' &&
      fitting !== 'Ceiling Mount' &&
      configuration === 'Centre Opening (2 Curtains)'
    ) {
      console.log('2',"======>kartik");
      return (
        <CurtainFaceMountDoublePleatCentreOpening
          {...props}
          ref={setProductImageRef}
        />
      );
    } else if (
      pleatType === 'Wave Pleat' &&
      fitting === 'Ceiling Mount' &&
      configuration === 'Centre Opening (2 Curtains)'
    ) {
      console.log('4',"======>kartik");
      return (
        <CurtainCeilingMountWaveFoldCentreOpening
          {...props}
          ref={setProductImageRef}
        />
      );
    }else if (
      pleatType === 'Double Pleat' &&
      (fitting === 'Ceiling Mount' || fitting === 'Wall Mount') &&
      configuration === 'Right Stack (1 Curtain)'
    ) {
      console.log('8',"======>kartik");
      return (
        <CurtainFaceMountDoublePleatRightStack
          {...props}
          ref={setProductImageRef}
        />
      );
    } else if (
      pleatType === 'Double Pleat' &&
      (fitting === 'Ceiling Mount' || fitting === 'Wall Mount') &&
      configuration === 'Left Stack (1 Curtain)'
    ) {
      console.log('9',"======>kartik");
      return (
        <CurtainFaceMountDoublePleatLeftStack
          {...props}
          ref={setProductImageRef}
        />
      );
    } else if (
      pleatType === 'Wave Pleat' &&
      (fitting === 'Ceiling Mount' || fitting === 'Wall Mount') &&
      configuration === 'Left Stack (1 Curtain)'
    ) {
      console.log('10,="=====>kartik"');
      return (
        <CurtainFaceMountWaveFoldLeftStack
          {...props}
          ref={setProductImageRef}
        />
      );
    } else if (
      pleatType === 'Wave Pleat' &&
      (fitting === 'Ceiling Mount' || fitting === 'Wall Mount') &&
      configuration === 'Right Stack (1 Curtain)'
    ) {
      console.log('11,="=====>kartik"');
      return (
        <CurtainFaceMountWaveFoldRightStack
          {...props}
          ref={setProductImageRef}
        />
      );
    } else if (
      pleatType === 'Single Pleat' &&
      (fitting === 'Ceiling Mount' || fitting === 'Wall Mount') &&
      configuration === 'Centre Opening (2 Curtains)'
    ) {
      console.log('12,="=====>kartik"');
      return (
        <CurtainFaceMountSinglePleatCentreOpening
          {...props}
          ref={setProductImageRef}
        />
      );
    }else if (
      pleatType === 'Single Pleat' &&
      (fitting === 'Ceiling Mount' || fitting === 'Wall Mount') && // Merged Ceiling and Wall Mount
      configuration === 'Left Stack (1 Curtain)'
    ) {
      console.log('16,="=====>kartik"');
      return (
        <CurtainFaceMountSinglePleatLeftStack
          {...props}
          ref={setProductImageRef}
        />
      );
    }
    else if (
      pleatType === 'Single Pleat' &&
      (fitting === 'Ceiling Mount' || fitting === 'Wall Mount') &&
      configuration === 'Right Stack (1 Curtain)'
    ) {
      console.log('17,="=====>kartik"');
      return (
        <CurtainFaceMountSinglePleatRightStack
          {...props}
          ref={setProductImageRef}
        />
      );
    } else if (
      pleatType === 'Single Pleat' &&
      fitting === 'Wall Mount' &&
      configuration === 'Centre Opening (2 Curtains)'
    ) {
      console.log('18,="=====>kartik"');
      return (
        <CurtainFaceMountSinglePleatCentreOpening
          {...props}
          ref={setProductImageRef}
        />
      );
    } else {
      console.log('19,="=====>kartik"');
      return (
        <CurtainCeilingDoublePleatCentreOpening
          {...props}
          ref={setProductImageRef}
        />
      );
    }
  },
);
